<template>
  <div class="d-flex">
    <div class="flex-grow-1">
      <a-row>
        <a-col :span="12" v-if="scope === 'domain'">
          <div class="card">
            <a-skeleton v-if="isShowSkeleton" />
            <template v-else>
              <div>
                <div class="card-title">
                  {{currentMonth}}
                  <a-tag color="orange" class="ml-2" v-if="billOverviewDetails.is_overdue">{{$t('scope.text_462')}}</a-tag>
                  <a-tag color="red" class="ml-2" v-if="billOverviewDetails.is_arrears">{{$t('scope.text_463')}}</a-tag>
                  <a-tag color="green" class="ml-2" v-if="!billOverviewDetails.is_overdue && !billOverviewDetails.is_arrears">{{$t('scope.text_464')}}</a-tag>
                </div>
                <div class="card-body d-flex">
                  <div class="flex-fill">
                    <span class="font-weight-bold money cursor-pointer" @click="handleMoneyClick('/bill-accounted')">
                    {{ getValue('due', billOverviewDetails) | numerify('0,0.00') }}
                    </span>
                    <span class="ml-2 f-12">{{billOverviewDetails.currency === 'CNY' ? $t('scope.text_468') : $t('scope.text_469')}}</span>
                    <h6 class="mt-2">{{$t('scope.text_466')}}</h6>
                  </div>
                  <div class="flex-fill">
                    <span class="font-weight-bold money cursor-pointer" @click="handleMoneyClick('/bill-pending-due')">
                    {{ getValue('pending_due', billOverviewDetails) | numerify('0,0.00') }}
                    </span>
                    <span class="ml-2 f-12">{{billOverviewDetails.currency === 'CNY' ? $t('scope.text_468') : $t('scope.text_469')}}</span>
                    <h6 class="mt-2">{{$t('scope.text_467')}}</h6>
                  </div>
                  <div class="flex-fill">
                    <span class="font-weight-bold money">
                    {{ totalSave }}
                    </span>
                    <span class="ml-2 f-12">{{billOverviewDetails.currency === 'CNY' ? $t('scope.text_468') : $t('scope.text_469')}}</span>
                    <h6 class="mt-2">{{$t('scope.text_470')}}</h6>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </a-col>
        <a-col :span="8" v-if="scope === 'project'">
          <div>
            <money-card
              :title="$t('bill.text_141')"
              :money="meterBalance.month_fee"
              height="122px"
              :showAlert="false"
              :btnTitle="$t('bill.text_96')"
              :currencyCn="currencyCn" />
          </div>
        </a-col>
        <a-col :span="6" v-if="scope === 'domain'">
          <div class="cloud-account-container ml-2">
            <a-list :data-source="cloudProvider" item-layout="vertical">
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta>
                  <div slot="title">{{ item.provider }}</div>
                  <div slot="description">{{$t('common_462', [ item.created_at ])}}</div>
                </a-list-item-meta>
                <img
                  class="provider-img"
                  slot="extra"
                  :src="image[item.provider.toLowerCase()]" />
                <div>
                  <span>{{$t('scope.text_802')}}{{ item.currency }}{{item.pending_due | numerify('0,0.00')}}</span>，
                  <span>{{$t('scope.text_803')}}{{ item.currency }}{{(item.total_origin - item.total_paid) | numerify('0,0.00')}}</span>
                </div>
                <template slot="actions">
                  <span @click="handleClickDashboard(item.provider.toLowerCase(), item)">
                    <icon type="kongzhitai" class="mr-2" />
                    {{$t('scope.text_804')}}
                  </span>
                </template>
              </a-list-item>
            </a-list>
          </div>
        </a-col>
        <a-col :span="6" v-if="scope === 'domain'">
          <div class="income-and-expenditure-details-container ml-2">
            <a-list :data-source="transactionList">
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta>
                  <div slot="title">{{ item.id }}</div>
                  <div slot="description">{{ $t('common_463') }}{{ transactionType[item.type] }}，{{ $t('scope.text_420') }}：{{ item.currency }}</div>
                </a-list-item-meta>
                <div :style="{ color: item.is_income ? '#3f8600' : '#cf1322' }">
                  <a-icon :type="item.is_income ? 'arrow-up' : 'arrow-down'" />
                  <span>{{ item.amount | numerify('0,0.00') }}</span>
                </div>
              </a-list-item>
            </a-list>
          </div>
        </a-col>
      </a-row>
      <a-divider />
      <a-row class="mt-4">
        <div class="mb-4" style="overflow: auto;">
          <a-radio-group class="float-right" v-for="item in OrderBtns" :key="item.value" v-model="activeOrderBtn">
            <a-radio-button :value="item.value">{{ item.text }}</a-radio-button>
          </a-radio-group>
        </div>
        <a-col>
          <consumption-trend
            class="mt-2"
            :header="monthHeader"
            :columns="orderColumns"
            :rows="orderRows"
            :labelMap="orderLabelMap"
            :setting-options="orderSettingOptions">
            <template #header-right>
              <currency class="float-right ml-2" />
              <a-radio-group class="float-right" v-model="productType" @change="orderTypeChange">
                <a-radio-button v-for="item in productTypes" :value="item.id" :key="item.id">
                  {{item.label}}
                </a-radio-button>
              </a-radio-group>
            </template>
          </consumption-trend>
        </a-col>
      </a-row>
      <bill-card :header="topHeader" class="mt-4">
        <div class="text-right">
          <a-radio-group v-model="top10Currency" @change="handleTop10CurrencyChange">
            <a-radio-button value="CNY">{{$t('op_67')}}</a-radio-button>
            <a-radio-button value="USD">{{$t('op_68')}}</a-radio-button>
          </a-radio-group>
          <a-button type="link" @click="routerPush('/bill-analysis')">{{$t('scope.text_805')}}<a-icon type="right" /> </a-button>
        </div>
        <div class="top10-content">
          <top10 :currencySign="top10Currency === 'USD' ? '$' : '￥'" :data="top10Data" :columns="columns" :bar-name="$t('scope.text_647')" :pie-title="$t('scope.text_806')" :pie-subtext="feeSubtotal" :chartSettings="topChartSettings" />
        </div>
      </bill-card>
    </div>
  </div>
</template>

<script>
import * as R from 'ramda'
import { mapGetters } from 'vuex'
import MoneyCard from '@Bill/sections/MoneyCard'
import Top10 from '../bill-analysis/components/Top10'
import BillCard from '@Bill/components/BillCard'
import { completionDate } from '@/utils/utils'
import { numerify } from '@/filters'
import currencyRequest from '@Bill/mixins/currencyRequest'
import currencyMixin from '@Bill/mixins/currency'
import store from '@/store'
import ConsumptionTrend from '../bill-overview/components/consumptionTrend'

export default {
  name: 'Overview',
  components: {
    MoneyCard,
    BillCard,
    Top10,
    ConsumptionTrend,
  },
  mixins: [currencyRequest, currencyMixin],
  data () {
    return {
      loading: false,
      meterBalance: {},
      monthHeader: {
        title: this.$t('scope.text_478'),
      },
      topHeader: {
        title: '',
      },
      OrderBtns: [
        {
          value: 'lastMonth',
          text: this.$t('scope.text_481'),
        },
        {
          value: 'month',
          text: this.$t('scope.text_480'),
        },
      ],
      topChartSettings: {
        radius: 180,
        offsetY: 260,
        dimension: ['sku'],
        metrics: ['subtotal'],
        itemStyle: {
          color: (params) => {
            return this.color[params.dataIndex]
          },
        },
        label: {
          normal: {
            show: false,
          },
          emphasis: {
            show: false,
          },
        },
        labelLine: {
          normal: {
            show: false,
          },
        },
      },
      notifyParams: {
        name: this.$t('scope.text_807'),
      },
      logParams: {
        limit: 5,
        name: this.$t('scope.text_435'),
      },
      transactionType: {
        exchange: this.$t('scope.text_680'),
        bill: this.$t('scope.text_681'),
        refund: this.$t('scope.text_682'),
        alipay: this.$t('scope.alipay'),
        tenpay: this.$t('scope.wechat_pay'),
        offline: this.$t('scope.text_685'),
        revoke: this.$t('scope.text_459'),
        transfer: this.$t('scope.text_686'),
      },
      activeOrderBtn: 'month',
      billOverviewDetails: {},
      currencyOrderHistoryData: [],
      orderHistoryData: [],
      formatOrderHistoryData: [],
      top10Data: [],
      image: {
        google: require('../../../src/assets/images/providers/google.svg'),
        huawei: require('../../../src/assets/images/providers/huawei.svg'),
        aliyun: require('../../../src/assets/images/providers/aliyun.svg'),
      },
      cloudProvider: [],
      color: ['#4DA1FF', '#FFC760', '#F76F89', '#5ED28A', '#ff5f2e', '#A593E0', '#7f9eb2', '#f6ea8c', '#a5dff9', '#77AAAD', '#c4ccd3'],
      orderColumns: ['time', 'origin_cost', 'subtotal'],
      orderRows: [],
      orderLabelMap: {
        origin_cost: this.$t('scope.text_483'),
        subtotal: this.$t('scope.text_484'),
      },
      orderSettingOptions: {
        origin_cost: {
          barWidth: 20,
          itemStyle: {
            color: '#ddd',
            borderColor: '#F1F1F1',
            borderType: 'dashed',
            opacity: 0.6,
          },
        },
        subtotal: {
          barWidth: 20,
          barGap: '-100%',
          z: 10,
          itemStyle: {
            color: '#4DA1FF',
            opacity: 0.6,
          },
        },
      },
      productType: 'subscription',
      productTypes: [{
        label: this.$t('scope.text_482'),
        id: 'subscription',
      }, {
        label: this.$t('scope.text_425'),
        id: 'commodity',
      }],
      transactionList: [],
      top10Currency: 'CNY',
    }
  },
  computed: {
    ...mapGetters(['scope', 'isDomainMode', 'isAdminMode']),
    // 当前月份
    currentMonth () {
      return this.$moment().format(this.$t('scope.text_808'))
    },
    // 累计节省
    totalSave () {
      if (!this.getValue('total_origin', this.billOverviewDetails)) {
        return 0
      }
      const num = Number(this.getValue('total_origin', this.billOverviewDetails)) - Number(this.getValue('total_paid', this.billOverviewDetails))
      return numerify(num, '0,0.00')
    },
    isShowSkeleton () {
      return R.isEmpty(this.billOverviewDetails)
    },
    selectedMonth () {
      if (this.activeOrderBtn === 'lastMonth') {
        return this.$moment().subtract(1, 'M').format('YYYYMM')
      }
      return this.$moment().format('YYYYMM')
    },
    orderHasCurrencyTypes () {
      return new Set(this.formatOrderHistoryData.map(item => item.currency))
    },
    feeSubtotal () {
      let num = 0
      const currencySign = this.top10Currency === 'USD' ? '$' : '￥'
      this.top10Data.map(item => {
        num += item.trans_subtotal
      })
      num = numerify(num, '0,0.00')
      return this.$t('scope.text_809', [currencySign + num])
    },
    columns () {
      const arr = [
        {
          field: 'color',
          title: this.$t('bill.text_115'),
          headerAlign: 'center',
          align: 'center',
          width: 60,
          slots: {
            default: ({ row }) => {
              return [<span style={{ display: 'inline-block', backgroundColor: row.color, width: '10px', height: '10px', borderRadius: '50%' }} />]
            },
          },
        },
        {
          field: 'sku',
          title: 'SKU',
          slots: {
            default: ({ row }, h) => {
              if (!row.sku) {
                return [<list-body-cell-wrap copy row={ row } field='sku' title={ row.sku } />]
              }
              return [<list-body-cell-wrap copy row={ row } field='sku' title={ row.sku } />]
            },
          },
        },
        {
          field: 'domain_name',
          title: this.$t('dictionary.domain'),
          slots: {
            default: ({ row }, h) => {
              if (!row.domain_name) {
                return [<list-body-cell-wrap copy row={ row } field='domain_name' title={ row.domain_name } />]
              }
              return [<list-body-cell-wrap copy row={ row } field='domain_name' title={ row.domain_name } />]
            },
          },
        },
        {
          field: 'sku_service',
          title: this.$t('op_110'),
          slots: {
            default: ({ row }, h) => {
              if (!row.sku_service) {
                return [<list-body-cell-wrap copy row={ row } field='sku_service' title={ row.sku_service } />]
              }
              return [<list-body-cell-wrap copy row={ row } field='sku_service' title={ row.sku_service } />]
            },
          },
        },
        {
          field: 'quantity',
          title: this.$t('bill.text_110'),
          width: 100,
          slots: {
            default: ({ row }, h) => {
              const money = numerify(row.quantity, '0,0.00')
              return [<list-body-cell-wrap copy={ false } row={ row } field='quantity' hideField title={ row.quantity } message={ row.quantity + '' }><div class="text-right">{money}</div></list-body-cell-wrap>]
            },
          },
        },
        {
          field: 'unit',
          title: this.$t('bill.text_111'),
          width: 110,
        },
        {
          field: 'trans_subtotal',
          title: this.$t('op_100'),
          align: 'right',
          headerAlign: 'right',
          width: 100,
          slots: {
            default: ({ row }, h) => {
              const money = numerify(row.trans_subtotal, '0,0.00')
              return [<div class="text-right" title={ row.trans_subtotal }>{this.top10Currency === 'USD' ? '$' : '￥'}{money}</div>]
            },
          },
        },
      ]
      if (this.isAdminMode) {
        return arr
      }
      arr.splice(2, 1)
      return arr
    },
    topDate () {
      if (this.activeOrderBtn === 'month') {
        return {
          start_date: this.$moment(new Date()).startOf('month').format('YYYY-MM-DD'),
          end_date: this.$moment(new Date()).format('YYYY-MM-DD'),
        }
      }
      return {
        start_date: this.$moment().subtract(1, 'M').startOf('month').format('YYYY-MM-DD'),
        end_date: this.$moment().subtract(1, 'M').endOf('month').format('YYYY-MM-DD'),
      }
    },
  },
  watch: {
    activeOrderBtn () {
      this.fetchData()
    },
  },
  beforeRouteEnter (to, from, next) {
    if (store.getters.isDomainMode || store.getters.isProjectMode) {
      next()
    } else {
      next('/dashboard')
    }
  },
  created () {
    this.accountM = new this.$Manager('billing_accounts')
    this.cloudsupplierM = new this.$Manager('cloudsupplier_customers')
    this.subscriptionM = new this.$Manager('billing_subscriptions')
    this.transactionM = new this.$Manager('billing_transactions')
    this.analysisM = new this.$Manager('bill_analysises', 'v1')
    this.balanceM = new this.$Manager('bill_balances', 'v1')
    this.dailieM = new this.$Manager('billing_dailies')
    this.fetchInitData()
  },
  methods: {
    fetchInitData () {
      this.fetchBillData()
      this.fetchData()
      if (this.scope === 'domain') {
        this.fetchCloudAccount()
        this.fetchBillingTransactions()
      }
      if (this.scope === 'project') {
        this.getBalance()
      }
    },
    orderTypeChange (e) {
      this.productType = e.target.value
      const data = this.filterTypeData(e.target.value)
      this.filterCurrencyData(this.currency, data)
    },
    getValue (key, target) {
      if (R.hasIn(key, target)) {
        return target[key]
      }
      return 0
    },
    async fetchBillData () {
      const { data: { data = [] } } = await this.accountM.list()
      const { data: res } = await this.accountM.getSpecific({
        id: data[0].id,
        spec: 'balance',
      })
      this.billOverviewDetails = res
      this.billAccountId = data[0].id
      this.fetchOrderHistoryData()
    },
    handleClickDashboard (provider, cloudProviderItem) {
      if (provider === 'google') {
        const newWindow = window.open()
        newWindow.opener = null
        newWindow.location = 'https://console.cloud.google.com/'
        newWindow.target = '_black'
        return
      }
      new this.$Manager('cloudsupplier_customers').getSpecific({
        id: cloudProviderItem.id,
        spec: 'login',
      }).then(res => {
        const newWindow = window.open()
        newWindow.opener = null
        newWindow.location = res.data.data.url
        newWindow.target = '_black'
      })
    },
    // 类型分为按需：subscription，commodity：预付费
    filterTypeData (type = 'subscription') {
      const ret = []
      this.formatOrderHistoryData.forEach(item => {
        if (type === item.type) {
          const obj = {
            time: item.time,
            currency: item.currency,
            subtotal: item.subtotal,
            origin_cost: item.origin_cost,
          }
          ret.push(obj)
        }
      })
      return ret
    },
    filterCurrencyData (currency, data) {
      if (data.length === 0) {
        this.orderRows = []
        return
      }
      // 过滤currency类型，默认使用数据中第一项
      const arr = R.clone(data.filter(item => item.currency === currency))
      // 根据时间进行去重合并，将处理结构处理为组件所需[{ time: 'xx', "subtotal": 'xx', "origin_cost": 'xx' }]
      for (let i = 0; i < arr.length; i++) {
        for (let j = i + 1; j < arr.length; j++) {
          if (arr[i].time === arr[j].time) {
            arr[i].subtotal = arr[j].subtotal
            arr[i].origin_cost = arr[j].origin_cost
            arr.splice(j, 1)
            j--
          }
        }
      }
      this.currencyOrderHistoryData = arr
      const formatArr = R.clone(arr)
      formatArr.map(item => {
        delete item.currency
        delete item.type
      })
      this.orderRows = completionDate(formatArr, this.selectedMonth, ['subtotal', 'origin_cost'])
    },
    genData (originData, resource) {
      // 处理原始数据类型为: [{ time: 'xxx', currency: 'xx', type: 'xx', "subtotal": 'XX', "origin_cost": 'xx' }]
      const list = []
      R.forEach((item) => {
        const time = item.date_str
        R.forEachObjIndexed((value, key) => {
          if (resource === 'order-history') {
            const currency = key
            R.forEachObjIndexed((value, key) => {
              const type = key
              const obj = {
                time,
                currency,
                type,
                subtotal: value.subtotal,
                origin_cost: value.origin_cost,
              }
              list.push(obj)
            }, value)
          }
          if (resource === 'bill-history') {
            const type = key
            const obj = {
              time,
              type,
              coupon_amount: value.coupon_amount,
              onpay_amount: value.onpay_amount,
              paid_amount: value.paid_amount,
            }
            list.push(obj)
          }
        }, item.record)
      }, originData)
      if (resource === 'order-history') {
        this.formatOrderHistoryData = list
        if (this.formatOrderHistoryData.length > 0) {
          const data = this.filterTypeData('subscription')
          this.filterCurrencyData(this.currency, data)
        }
      }
    },
    async fetchOrderHistoryData () {
      const { data: historyData } = await this.accountM.getSpecific({
        id: this.billAccountId,
        spec: 'order-history',
        params: {
          month: this.selectedMonth,
          timezone: '',
        },
      })
      this.orderHistoryData = historyData.history || []
      if (this.orderHistoryData.length === 0) {
        this.orderRows = []
        this.formatOrderHistoryData = []
      } else {
        this.genData(this.orderHistoryData, 'order-history')
      }
    },
    handleMoneyClick (path) {
      this.$router.push(path)
    },
    async fetchCloudAccount () {
      const { data: { data = [] } } = await this.cloudsupplierM.list({
        params: {
          scope: this.scope,
          limit: 0,
        },
      })
      data.map(item => {
        this.subscriptionM.getSpecific({
          id: item.billing_subscription_id,
          spec: 'balance',
        }).then(({ data }) => {
          const obj = {
            id: item.id,
            billing_subscription_id: item.billing_subscription_id,
            provider: item.provider,
            pending_due: data.pending_due || 0,
            total_origin: data.total_origin || 0,
            total_paid: data.total_paid || 0,
            currency: data.currency === 'USD' ? '$' : '￥',
            created_at: this.$moment(item.created_at).format('YYYY-MM-DD HH:mm:ss'),
          }
          this.cloudProvider.push(obj)
        })
      })
    },
    viewDashboard (obj) {
      if (obj.provider.toLowerCase() === 'google') {
        const newWindow = window.open()
        newWindow.opener = null
        newWindow.location = 'https://console.cloud.google.com/'
        newWindow.target = '_black'
        return
      }
      new this.$Manager('cloudsupplier_customers').getSpecific({
        id: obj.id,
        spec: 'login',
      }).then(res => {
        const newWindow = window.open()
        newWindow.opener = null
        newWindow.location = res.data.data.url
        newWindow.target = '_black'
      })
    },
    fetchData () {
      this.fetchTop10Data()
      this.fetchOrderHistoryData()
    },
    handleTop10CurrencyChange (e) {
      this.fetchTop10Data({ currency: e.target.value })
    },
    async fetchTop10Data (others = {}) {
      const { data: { data } } = await this.dailieM.list({
        params: {
          scope: this.scope,
          from: this.topDate.start_date,
          to: this.topDate.end_date,
          group_by: 'sku_id',
          limit: 10,
          order_by: 'used_at',
          order: 'asc',
          ...others,
        },
      })
      this.top10Data = data.map((v, i) => ({ ...v, color: this.color[i] }))
    },
    routerPush (path) {
      this.$router.push(path)
    },
    async fetchBillingTransactions () {
      const { data: { data = [] } } = await this.transactionM.list({
        params: {
          scope: this.$store.getters.scope,
          show_fail_reason: true,
          details: true,
          currency_ex: 'POINT',
          limit: 20,
        },
      })
      this.transactionList = data
    },
    async getBalance () {
      try {
        const { data } = await this.balanceM.get({
          id: 'billOverview',
          params: {
            admin: this.isAdminMode,
            scope: this.scope,
            account: 'billOverview',
            ...this.currencyParams,
          },
        })
        this.meterBalance = data
      } catch (error) {
        throw error
      }
    },
  },
}
</script>

<style lang="less" scoped>
.cursor-pointer {
  cursor: pointer;
}
.provider-img {
  width: 100px;
  height: 100px;
  margin: 0 auto;
}
.wrap-right {
  width: 380px;
  .right-item {
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
  }
}
.card {
  width: 100%;
  height: 173px;
  border: 1px solid #F1F1F1;
  padding: 12px 24px;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
  .card-title {
    font-size: 16px;
  }
  .card-body {
    margin-top: 20px;
    .money {
      font-size: 32px;
      color: rgb(77, 161, 255);
    }
  }
}
.cloud-account-container, .income-and-expenditure-details-container {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  overflow: auto;
  padding: 8px 24px;
  height: 173px;
}
</style>
